import React, { Fragment, useEffect, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import { useParams } from 'react-router-dom';
import FormValidator from '../../../inc/FormValidator';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import Collapse from '../../inc/Collapse';
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import { areObjectsDifferent, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import SimpleLoading from '../../Loading/SimpleLoading';
import Helper from '../../../inc/Helper';
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls';

let defaultCredentialStoreFormsObject = null;
const CredentialStoreFormsDetailView = () => {
  const [credentialStoreFormsData, setCredentialStoreFormsData] = useState({});
  const [appMaster, setAppMaster] = useState([]);
  
  const [loading, setLoading] = useState(true); 

  const { id } = useParams();

  let getByIdApiCall = false; 

  useEffect(() => { 
    getCredentialStoreFormsById();
    fetchDataForAppMaster();
  }, [])

  let validator;

  const validationConfigure = () => {
    let fieldConfig = [ 
      { name: "login_id", displayName: "User email", types: ["Required", "Email"] },
      { name: "login_password", displayName: "Password", types: ["Required"] }, 
      { name: "api_master", displayName: "App", types: ["Required"] }, 
      // { name: "token", displayName: "Token", types: ["Required"] },
    ];

    if(!validator) {
      validator = new FormValidator(fieldConfig)
    }
  }

  validationConfigure();

  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemApiDetails();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }

  const getCredentialStoreFormsById = () => { 
    if(getByIdApiCall) return;

    getByIdApiCall = true;
    setLoading(true);

    let api = Api;
    api.setUserToken();
    api.axios().get(Settings.apiAppUrl+`/credentials/${id}/`,{}).then(function(res){
      if(res?.status === 200){ 
        setCredentialStoreFormsData(res?.data);
        defaultCredentialStoreFormsObject = res?.data;
        setLoading(false);
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => { 
      getPopupMessageBasedOnStatus(res) 
      setLoading(false)
    })
  }

  const CredentialsStoreForms = () => {
    let textBoxInputSettings = [ 
      {
        className: "col-lg-4",
        label: "User email",
        inputType: "text",
        required: true,
        id: "login_id",
        name: "login_id",
      },
      {
        className: "col-lg-4",
        label: "Password",
        inputType: "password_eye",
        required: true,
        id: "login_password",
        name: "login_password",
      },
      {
        className: "col-lg-4",
        label: "App",
        inputType: "dropdown",
        options: appMaster,
        required: true,
        id: "api_master",
        name: "api_master",
      }, 
      // {
      //   className: "col-lg-4",
      //   label: "Token",
      //   inputType: "text",
      //   id: "token",
      //   required: true,
      //   name: "token",
      // } 
    ];

    return (
      <Collapse open={true} title={"General"}>
        <div className='row mb-3'>
          <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setCredentialStoreFormsData} currentState={credentialStoreFormsData} />
        </div>
      </Collapse>
    )
  }

  const SaveHandler = () => {
    if(!areObjectsDifferent(defaultCredentialStoreFormsObject, credentialStoreFormsData)) return;
    
    let validData = {
      ...credentialStoreFormsData
    };

    if(!validator.isValid(validData)){
      validator.displayMessage();
      validator.reset() 
      return;
    };

    let api = Api;
    api.setUserToken();

    api.axios().put(Settings.apiAppUrl+`/credentials/${id}/`, credentialStoreFormsData).then(function(res){
      if(res?.status === 200){
        Helper.alert(res?.data?.message || 'Credential store updated successfully', 'success');
        getCredentialStoreFormsById();
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => {  
      getPopupMessageBasedOnStatus(res);
    })  
  }

  return (
    <div className='container-fluid'>
      <NavigationHeder title={ `<span style="color:#000;"> Edit Credential Store #</span> ${credentialStoreFormsData.tenant}` }>
        <LinkBtn to={-1} isActive= {false} title={"Close"} />
        <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
      </NavigationHeder>

      {loading ? <SimpleLoading /> : (
        <Fragment>
          {CredentialsStoreForms()} 
        </Fragment>
      )} 
    </div>
  )
}

export default (MasterComponentWraper(CredentialStoreFormsDetailView));